/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Offline_Kind_EndInputs */

const en_us2_offline_kind_end = /** @type {(inputs: Offline_Kind_EndInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Workout end`)
};

const pt_br2_offline_kind_end = /** @type {(inputs: Offline_Kind_EndInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fim do treino`)
};

const es_419_offline_kind_end = /** @type {(inputs: Offline_Kind_EndInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fin del entrenamiento`)
};

const pt_pt2_offline_kind_end = /** @type {(inputs: Offline_Kind_EndInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fim do treino`)
};

const fr_fr2_offline_kind_end = /** @type {(inputs: Offline_Kind_EndInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fin de séance`)
};

const de_de2_offline_kind_end = /** @type {(inputs: Offline_Kind_EndInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trainingsende`)
};

const it_it2_offline_kind_end = /** @type {(inputs: Offline_Kind_EndInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fine allenamento`)
};

/**
* | output |
* | --- |
* | "Workout end" |
*
* @param {Offline_Kind_EndInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const offline_kind_end = /** @type {((inputs?: Offline_Kind_EndInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Offline_Kind_EndInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_offline_kind_end(inputs)
	if (locale === "es-419") return es_419_offline_kind_end(inputs)
	if (locale === "pt-PT") return pt_pt2_offline_kind_end(inputs)
	if (locale === "fr-FR") return fr_fr2_offline_kind_end(inputs)
	if (locale === "de-DE") return de_de2_offline_kind_end(inputs)
	if (locale === "it-IT") return it_it2_offline_kind_end(inputs)
	return en_us2_offline_kind_end(inputs)
});
export { offline_kind_end as "offline.kind_end" }